<template>
  <div v-if="article">
    <article-detail-component v-if="!$store.state.isEnhanced">

      <div slot="keywords" class="keywords">
        <div class="title">
          Keywords:
        </div>
        <div class="">
          <div class="link" v-for="keyword in article.keywords">{{keyword}}</div>
        </div>
      </div>

      <div slot="title">
        <div class="title">{{ article.title }}</div>
        <issue-authors v-bind:authors="article.authors"></issue-authors>
      </div>
      <sidebar-article-section slot="bar" :article="article"></sidebar-article-section>

    </article-detail-component>


    <section>
      <div class="row">
        <div class="col-xs-12 col-lg-6">
          <div class="row">
            <div class="col-6"><b>Alt Metric</b></div>
            <div class="col-6 text-right"><b>29,876</b> Score</div>
            <div class="col-12">
              <div class="img h2"></div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-lg-6">
          <div class="row">
            <div class="col-6"><b>Views:</b></div>
            <div class="col-6 text-right"><b>29,876</b> Total Views</div>
            <div class="col-12">
              <div class="img h1"></div>
            </div>
            <div class="col-xs-12 col-sm-6">
              <div class="img h1"></div>
            </div>
            <div class="col-xs-12 col-sm-6">
              <div class="img h1"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-6"><b>Citations:</b></div>
        <div class="col-6 text-right"><b>29,876</b> Total Citations</div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="img h1"></div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="img h1"></div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="img h1"></div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="img h1"></div></div>
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-6"><b>Mentions</b></div>
        <div class="col-6 text-right"><b>29,876</b> Total Mentions</div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="btn active">News (123)</div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="btn btn-default">Scientific Blogs (123)</div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="btn btn-default">Google+ (123)</div></div>
        <div class="col-xs-12 col-sm-6 col-lg-3"><div class="btn btn-default">Citations (123)</div></div>
      </div>
      <p><a href="">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.</a></p>
      <p><a href="">Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.</a></p>
      <p><a href="">Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</a></p>
      <p><a href="">Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget.</a></p>
    </section>

    <section>
      <div class="row">
        <div class="col-6"><b>Social Attention:</b></div>
        <div class="col-6 text-right"><b>29,876</b> Total Shares</div>
        <div class="col-xs-12 col-md-3 col-lg-3">
          <div class="img h1"></div>
          <div class="img h1"></div>
          <div class="img h1"></div>
        </div>
        <div class="col-xs-12 col-md-9"><div class="img h3"></div></div>
      </div>
    </section>

  </div>
</template>

<script>
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import ArticleDetailComponent from '@/components/publications/article-detail/ArticleDetailComponent'
  import SidebarArticleSection from '@/components/main-layout/sidebar/SidebarArticleSectionComponent'

  export default {
    name: 'metrics',
    components: {
      IssueAuthors,
      ArticleDetailComponent,
      SidebarArticleSection
    },
    data () {
      return {
        article: false
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-detail'}
      this.$parent.$parent.nextPage = {name: 'article-interact'}
      this.$parent.$parent.prevSlide = false
      this.$parent.$parent.nextSlide = {name: 'article-metrics-geographics'}
      if (this.$store.state.isEnhanced) {
        this.$parent.$parent.toggleHeader()
      }
      if (this.$parent.article) {
        this.article = Object.assign({}, this.$parent.article)
      }
    }
  }
</script>


<style scoped lang="scss">
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  section {
    margin: 20px auto;
    padding-bottom: 12px;
    &:not(:last-child) {
      border-bottom: 1px solid #cccccc;
    }
    p {
      font-size: 14px;
      text-decoration: underline;
      color: $grey-font;
    }
    .text-right {
      font-size: 12px;
      line-height: 24px;
      font-style: italic;
    }
    .img {
      border: 1px solid #cccccc;
      background-color: #eeeeee;
      width: 100%;
      &.h1 {
        height: 160px;
      }
      &.h2 {
        height: calc(320px + 0.5rem);
      }
      &.h3 {
        height: calc(480px + 1rem);
      }
    }
    .btn {
      padding: 10px;
      border: 1px solid #dfdfdf;
      width: 100%;
      text-align: center;
      font-size: 12px;
      margin-bottom: 10px;
      &.active {
        background-color: #cccccc;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// MetricsPage.vue?68722bfc